export default __webpack_public_path__ + "static/Cart-Pro-Systems-fa3b93d2d60f968689c9d0f55d351b60.webp";